import * as React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import { Typography, withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import PercentageNumber from "../UI/PercentageNumber";
import moment from "moment";
import { useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const styles = (theme) => ({
  managerWrapper: {
    marginBottom: 10,
  },
  table: {
    width: "100%",
    tableLayout: "fixed",
    "& th": {
      background: theme.palette.primary.light,
      fontSize: 14,
      lineHeight: 1.6,
      "@media print": {
        fontSize: 11,
      },
    },
  },
  tableCell: {
    padding: "0 2px",
    fontSize: 12,
    maxWidth: 65,
    "@media print": {
      fontSize: 11,
    },
    "&.header": {
      maxWidth: 65,
      fontSize: 13,
      wordWrap: "break-word",
      fontWeight: 500,
      color: theme.palette.primary.main,
      "@media print": {
        fontSize: 11,
      },
    },
  },
  managerName: {
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontWeight: 400,
    lineHeight: 2,
    display: "flex",
    "&:hover": {
      background: theme.palette.grey[100],
    },
  },
  managerData: {
    overflow: "hidden",
    height: 0,
    transition: "all 0.3s ease",
    "@media print": {
      height: "auto",
    },
    "&.visible": {
      height: "auto",
    },
  },
});

const CyPortfolioModelConstituentDisclosure = (props) => {
  const { classes, modelConstituentDisclosure, managerList, userIsApproved } = props;
  const columnSize = 4;
  const [expanded, setExpanded] = useState("");
  const toggleExpanded = (managerCode) => (e) => {
    setExpanded(expanded === managerCode ? "" : managerCode);
  };

  if (!modelConstituentDisclosure) {
    return null;
  }

  return (
    <React.Fragment>
      {modelConstituentDisclosure.map((model) => {
        const manager = managerList.find(
          (m) => m.managerCode === model.managerCode
        );
        if (manager) {
          const managerName = manager.managerDetail.ImplementationName;
          const managerType = manager.managerDetail.GlobalCategory;
          const constituent = model.constituent;
          // Making sure index ticker or 'backtest' is always in the front
          const tickers = Object.keys(constituent).sort((a, b) =>
            a.toLowerCase().indexOf("index") > -1 ||
            a.toLowerCase().indexOf("backtest") > -1
              ? -1
              : 1
          );
          const tableSize = constituent[tickers[0]].length;
          const tableChunk = Math.ceil(tableSize / 4);

          return (
            <div key={model.managerCode} className={classes.managerWrapper}>
              <Typography
                variant={"body1"}
                onClick={toggleExpanded(model.managerCode)}
                className={classes.managerName}
              >
                {userIsApproved ? managerName : '********'}
                {model.managerCode === expanded ? (
                  <ExpandLessIcon color={"primary"} />
                ) : (
                  <ExpandMoreIcon color={"primary"} />
                )}
              </Typography>
              {
                <section
                  className={`${classes.managerData} ${
                    model.managerCode === expanded && "visible"
                  }`}
                >
                  <Typography variant={"body1"} gutterBottom>
                    Type: {managerType}
                  </Typography>
                  <Grid container spacing={2}>
                    {Array(columnSize)
                      .fill("")
                      .map((f, colIndex) => {
                        return (
                          <Grid
                            item
                            xs={12 / columnSize}
                            key={`col-${colIndex}`}
                          >
                            <Table className={classes.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell className={classes.tableCell}>
                                    Month
                                  </TableCell>
                                  {tickers.map((ticker) => {
                                    return (
                                      <TableCell
                                        className={classes.tableCell}
                                        key={`header-${ticker}`}
                                        align={"center"}
                                      >
                                        {userIsApproved ? ticker : '********'}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {constituent[tickers[0]].map((d, index) => {
                                  if (
                                    index >= tableChunk * colIndex &&
                                    index < tableChunk * (colIndex + 1)
                                  ) {
                                    return (
                                      <TableRow key={`row-${index}`} hover>
                                        <TableCell
                                          className={classes.tableCell}
                                          size={"small"}
                                        >
                                          {moment(d["Date"]).format("MM/YYYY")}
                                        </TableCell>
                                        {tickers.map((ticker) => {
                                          return (
                                            <TableCell
                                              className={classes.tableCell}
                                              key={`return-${index}-${ticker}`}
                                              align={"center"}
                                              size={"small"}
                                            >
                                              <PercentageNumber
                                                value={
                                                  constituent[ticker][index][
                                                    "Return"
                                                  ]
                                                }
                                              />
                                            </TableCell>
                                          );
                                        })}
                                      </TableRow>
                                    );
                                  } else {
                                    return null;
                                  }
                                })}
                              </TableBody>
                            </Table>
                          </Grid>
                        );
                      })}
                  </Grid>
                </section>
              }
            </div>
          );
        } else {
          return null;
        }
      })}
    </React.Fragment>
  );
};

CyPortfolioModelConstituentDisclosure.propTypes = {
  classes: PropTypes.object.isRequired,
  modelConstituentDisclosure: PropTypes.arrayOf(
    PropTypes.shape({
      managerCode: PropTypes.string,
      constituent: PropTypes.object,
    })
  ),
  managerList: PropTypes.array,
  userIsApproved: PropTypes.bool.isRequired
};

export default withStyles(styles)(CyPortfolioModelConstituentDisclosure);



// WEBPACK FOOTER //
// ./src/components/Charts/CyPortfolioModelConstituentDisclosure.jsx